module.exports = __webpack_public_path__ + "fonts/ubuntu-v14-latin-500.111af58.woff2";